<template>
    <div class="main-wrap default-page sitemap">
        <div class="row justify-center q-col-gutter-x-xl q-my-lg">
            <h3 class="col-12">
                {{ $t('footers.site_map') }}
            </h3>
        </div>
        <div class="row justify-center q-col-gutter-x-xl">
            <div class="col-12 col-md-6 text-body1">
                <router-link to="/">{{ $t('general.home') }}</router-link>
                <ul class="text-secondary">
                    <li>
                        <router-link to="/areas">{{
                            $tc('general.training_areas', 2)
                        }}</router-link>
                        <ul>
                            <li v-for="(area, index) in areas" :key="index">
                                <router-link
                                    :to="{
                                        name: 'Courses',
                                        params: {
                                            areaId: area.id,
                                        },
                                    }"
                                    >{{
                                        JSONParseTranslations(
                                            area.title,
                                            locale.key
                                        )
                                    }}</router-link
                                >
                            </li>
                        </ul>
                    </li>
                    <li>
                        <router-link to="/partners">{{
                            $tc('general.partners', 2)
                        }}</router-link>
                        <ul>
                            <li
                                v-for="(partner, index) in partners"
                                :key="index"
                            >
                                <router-link
                                    :to="{
                                        name: 'PartnersDetails',
                                        params: {
                                            partnerId: partner.id,
                                        },
                                    }"
                                    >{{
                                        JSONParseTranslations(
                                            partner.title,
                                            locale.key
                                        )
                                    }}</router-link
                                >
                            </li>
                        </ul>
                    </li>
                    <li>
                        <span class="capitalize-text">{{
                            $t('general.about_us')
                        }}</span>
                        <ul>
                            <li>
                                <router-link to="/about">{{
                                    $t('general.about_cfma')
                                }}</router-link>
                            </li>
                            <li>
                                <router-link to="/news">{{
                                    $t('general.news')
                                }}</router-link>
                            </li>
                            <li>
                                <router-link to="/about/history">{{
                                    $t('general.history')
                                }}</router-link>
                            </li>
                            <li>
                                <router-link to="/about/team"
                                    >{{ $t('general.team') }} CFMA</router-link
                                >
                            </li>
                            <li>
                                <router-link to="/about/certificates-awards"
                                    >{{ $t('general.certifications') }} /
                                    {{ $t('general.awards') }}</router-link
                                >
                            </li>
                            <li>
                                <router-link to="/about/mission">{{
                                    $t('general.mission-vision-values')
                                }}</router-link>
                            </li>
                        </ul>
                    </li>
                </ul>

                <div class="q-mt-md">
                    <router-link to="/terms-and-services">{{
                        $t('footers.service_terms')
                    }}</router-link>
                </div>
                <div class="q-mt-md">
                    <router-link to="/privacy-policy">{{
                        $t('footers.privacy_policy')
                    }}</router-link>
                </div>
            </div>
            <div class="col-12 col-md-6 text-body1">
                <router-link to="/profile">{{
                    $t('general.profile')
                }}</router-link
                ><br />
                <ul v-if="isStudent" class="text-secondary">
                    <li>
                        <router-link to="/profile/my-tax-address">{{
                            $t('profile.my_tax_address')
                        }}</router-link>
                    </li>
                    <li>
                        <router-link to="/profile/my-account">{{
                            $t('profile.my_account')
                        }}</router-link>
                    </li>
                    <li>
                        <router-link to="/profile/my-affiliations">{{
                            $t('profile.my_affiliations')
                        }}</router-link>
                    </li>
                    <!-- <li>
                        <router-link to="/profile/notifications">{{
                            $t('profile.notifications')
                        }}</router-link>
                    </li> -->
                    <li>
                        <router-link to="/profile/my-courses">{{
                            $t('profile.my_courses')
                        }}</router-link>
                    </li>
                    <li>
                        <router-link to="/profile/certificates">{{
                            $t('profile.certificates')
                        }}</router-link>
                    </li>
                    <li>
                        <router-link to="/profile/orders-history">{{
                            $t('profile.orders_history')
                        }}</router-link>
                    </li>
                </ul>
                <ul v-if="isClient" class="text-secondary">
                    <li>
                        <router-link to="/profile/my-account">{{
                            $t('profile.my_account')
                        }}</router-link>
                    </li>
                    <!-- <li>
                        <router-link to="/profile/notifications">{{
                            $t('profile.notifications')
                        }}</router-link>
                    </li> -->
                    <li>
                        <router-link to="/profile/organization">{{
                            $t('profile.organization')
                        }}</router-link>
                    </li>
                    <li>
                        <router-link to="/profile/my-tax-address">{{
                            $t('profile.our_tax_address')
                        }}</router-link>
                    </li>
                    <li>
                        <router-link to="/profile/employees">{{
                            $t('profile.employees')
                        }}</router-link>
                    </li>
                    <li>
                        <router-link to="/profile/our-courses">{{
                            $t('profile.our_courses')
                        }}</router-link>
                    </li>
                    <li>
                        <router-link to="/profile/certificates">{{
                            $t('profile.certificates')
                        }}</router-link>
                    </li>
                    <li>
                        <router-link to="/profile/orders-history">{{
                            $t('profile.orders_history')
                        }}</router-link>
                    </li>
                </ul>
                <div class="q-mt-md">
                    <router-link to="/wishlist">{{
                        $t('general.wishlist')
                    }}</router-link>
                </div>
                <div class="q-mt-md">
                    <router-link to="/cart">{{
                        $t('general.shopping_cart')
                    }}</router-link>
                </div>
                <div class="q-mt-md">
                    <router-link to="/login">{{
                        $t('actions.login')
                    }}</router-link>
                </div>
                <div class="q-mt-md">
                    <router-link to="/sign-up">{{
                        $t('actions.signup')
                    }}</router-link>
                </div>
                <div class="q-mt-md">
                    <router-link to="/contact">{{
                        $t('footers.contact')
                    }}</router-link>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import translate from '@/local-shared/mixins/translate'
import partnersService from '@/services/modules/partners'
import areasService from '@/services/modules/areas'
import store from '@/store'

const loadingKeys = {
    fetchingPartners: 'fetching-partners',
    fetchingAreas: 'fetching-areas',
}

export default {
    name: 'Sitemap',

    mixins: [translate],

    data() {
        return {
            partners: [],
            areas: [],
        }
    },

    computed: {
        locale() {
            return store.getters['locale/currentLocale']
        },

        user() {
            return store.getters['session/user']
        },

        isStudent() {
            return this.user ? this.user.userRoles.name === 'student' : false
        },

        isClient() {
            return this.user ? this.user.userRoles.name === 'client' : false
        },
    },

    async created() {
        await this.fetchPartners()
        await this.fetchAreas()
    },

    methods: {
        async fetchPartners() {
            this.loadingAdd(loadingKeys.fetchingPartners)

            let parameters = {
                filter: {
                    active: true,
                    on_partners_page: true,
                },

                orderBy: [
                    {
                        column: 'title',
                        direction: 'asc',
                    },
                ],
            }

            let response = await partnersService.partners.retrieve(parameters)

            if (response.status === 200) {
                this.partners = response.data.results
            } else {
                this.$q.notify({
                    type: 'negative',
                    message: this.$t('notify.error_occurred', {
                        message: response.data.message,
                    }),
                })
            }

            this.loadingRemove(loadingKeys.fetchingPartners)
        },

        async fetchAreas() {
            this.loadingAdd(loadingKeys.fetchingAreas)

            let parameters = {
                filter: {
                    active: true,
                    published: true,
                },

                orderBy: [
                    {
                        column: 'title',
                        direction: 'asc',
                    },
                ],
            }

            let response = await areasService.retrieve(parameters)

            if (response.status === 200) {
                this.areas = response.data.results
            }

            this.loadingRemove(loadingKeys.fetchingAreas)
        },
    },
}
</script>
